import { render } from "./OpenSuccessView.vue?vue&type=template&id=03fc05c0&scoped=true&ts=true"
import script from "./OpenSuccessView.vue?vue&type=script&lang=ts"
export * from "./OpenSuccessView.vue?vue&type=script&lang=ts"

import "./OpenSuccessView.vue?vue&type=style&index=0&id=03fc05c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fc05c0"]])

export default __exports__